import { render, staticRenderFns } from "./InsurancesPlanForm.vue?vue&type=template&id=016f1c06&scoped=true&"
import script from "./InsurancesPlanForm.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f1c06",
  null
  
)

export default component.exports